import { createComponent } from '@carvana/merch-components';

export const Content = createComponent('div', {
  className: 'flex w-[327px] flex-row flex-wrap m:w-[488px] l:w-full'
});

export const Disclaimer = createComponent('div', {
  className:
    'w-[327px] text-center font-sans text-xs leading-4 text-grey-5 l:text-left'
});

export const H4 = createComponent('h4', {
  className: `
    pt-24
    text-center
    text-[32px]
    font-bold
    leading-[44px]
    text-blue-6
    m:text-[40px]
    l:pt-0
    l:text-left
  `
});

export const SectionWrapper = createComponent('div', {
  className: 'flex-0 m-auto w-[327px] max-w-[327px] l:ml-40'
});

export const Text = createComponent('div', {
  className:
    'mt-12 text-center text-base leading-normal text-grey-5 l:text-left'
});

export const Wrapper = createComponent('div', {
  className:
    'flex justify-center pt-[30px] m:w-full m:pb-[60px] m:pt-20 l:p-[60px]'
});
